/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ArrowLeftIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "arrow-left", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M6.5 12.5H19", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12 18L6.5 12.5L12 7", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ArrowLeftIcon);
export default ForwardRef;
//# sourceMappingURL=arrowLeftIcon.js.map